// Library imports
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";

// Interface imports
import { IConfig } from "../../models/config.model";

export const getConfig = createAsyncThunk(
  "getConfigData",
  async (): Promise<IConfig> => {
    // console.log("getting config");
    const response: AxiosResponse<any> = await axios.get(
      `${process.env.PUBLIC_URL}/data/config.json`
    );

    return response.data;
  }
);

export const postDetails = createAsyncThunk(
  "postDetailsData",
  async ({ role, unit }: { role: string; unit: string }): Promise<any> => {
    // console.log("getting config");
    const response: AxiosResponse<any> = await axios.post(
      "https://dev.creator.digi-sim-api.co.uk/virtual",
      {
        role: role,
        unit: unit,
        date: new Date().toISOString(),
      }
    );

    return response.data;
  }
);

export const postFeedback = createAsyncThunk(
  "postDetailsData",
  async ({
    feedback,
    other,
  }: {
    feedback: string;
    other: string;
  }): Promise<any> => {
    // console.log("getting config");
    const response: AxiosResponse<any> = await axios.post(
      "https://dev.creator.digi-sim-api.co.uk/virtual",
      {
        feedback: feedback,
        other: other,
        date: new Date().toISOString(),
      }
    );

    return response.data;
  }
);
